<script setup lang="ts">
defineProps<{
  explain: string | null
  packageName: keyof typeof EXPLAIN_DICT | string
}>()

defineEmits(['close'])

const EXPLAIN_DICT = {
  'com.roblox.client': `<b>W/A/S/D</b> - Movement\n<b>Spacebar</b> - Jump or Climb\n<b>Click and drag with your left mouse to change view</b>`,
  'jp.konami.pesam': `<b>W/A/S/D</b> - Movement\n<b>Pass</b> - Use the WASD select the direction + K\n<b>Through Ball</b> - Use the W/A/S/D select the direction + O\n<b>Shoot</b> - Use the W/A/S/D select the direction + P\n<b>Dash</b> - Use the W/A/S/D select the direction + L\n<b>Set Pieces</b> - Draw path with mouse`,
  'com.kiloo.subwaysurf': `<b>A/D</b> - left/right\n<b>W/S</b> - up to jump / down to roll\n<b>Double-tap the left mouse button</b> - summon your hoverboard\n<b>Special Items:</b> 1 for item 1, 2 for item 2<br><br><span class="text-3.5 c-#fff c-op-90 lh-3.5 font-600">Mouse Controls</span>\nMove Left/Right: flick the mouse left and right\nUp to jump: Click and flick mouse up\nDown to roll: Click and flick mouse down`,
  'com.MOBGames.PoppyMobileChap2': `<b>W/A/S/D</b> - Movement\n<b>Spacebar</b> - Jump\n<b>Left Hand</b> - Aim + Q\n<b>Right Hand</b> - Aim + R\n<b>Click and drag with your left mouse to change view</b>`,
  'com.supercell.brawlstars': `<b>W/A/S/D</b> - Movement\nSpacebar - release the shoot\nQ - Super Ability (release your Super to shoot the BOSS)\nDouble Press the Spacebar - Auto Aim<br><br><span class="text-3.5 c-#fff c-op-90 lh-3.5 font-600">Mouse Controls</span>\nClick and drag with your left mouse to aim your shots (Red control)\nClick the left mouse to shoot at the closest enemy (Yellow control)\nClick the Icons with Mouse - Gadgets and Star Powers`,
  'com.innersloth.spacemafia': `<b>W/A/S/D</b> - Movement\nE - Use an Object or Interact\nUse the Mouse to Click the Icon on Screen - Perform kill\nUse the Mouse to Click the Icon on Screen - Report a body`,
  'com.supercell.clashofclans': `<b>Pan Across the Farm:</b> Pan across the farm by clicking and dragging the mouse.\n<b>Selection and Placement:</b> Click and drag to place buildings, crops, and decorations.\n<b>Harvesting Crops and Collecting Items:</b> Click to to collect items from machines, trees, and animals.\n<b>Navigating Menus:</b> Click on icons for the newspaper, mailbox, shop, and other menus.`,
  'com.supercell.hayday': `<b>Selection and Placement:</b> Use your mouse to select and place buildings, troops, and spells.\n<b>Pan Across Maps:</b> Pan across the village or battlefield by clicking and dragging the mouse.\n<b>Game Menus:</b> Access various game menus and options by clicking on the respective icons on the screen.`,
}
</script>

<template>
  <div class="relative max-h-55.5 w-75 flex flex-col items-start rd-2 bg-gray-4 bg-opacity-90 px-2 py-6">
    <span class="pis-4 text-3.5 c-#fff c-op-90 font-600 lh-3.5">{{ $t('gameDetail.contrlTipsTitle') }}</span>
    <p class="content-panel mt-4 max-h-36 w-full overflow-y-auto ws-pre-line pis-4 text-start text-3.5 c-#fff c-op-50 lh-4.5" style="-webkit-mask: linear-gradient(to bottom, #000 0%, #000 80%, transparent);" v-html="explain || EXPLAIN_DICT[packageName as keyof typeof EXPLAIN_DICT] || ''" />
    <svg class="absolute inset-is-50% bottom-0.25 translate-x--50% translate-y-100%" width="24" height="6" viewBox="0 0 24 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_92_1612)">
        <path opacity="0.9" d="M13.2 5.1L17.8667 1.6C19.2514 0.561423 20.9357 -1.33945e-07 22.6667 -5.82818e-08L1.33333 -9.90791e-07C3.06429 -9.15129e-07 4.74856 0.561422 6.13333 1.6L10.8 5.1C11.5111 5.63333 12.4889 5.63333 13.2 5.1Z" fill="#262626" />
      </g>
      <defs>
        <clipPath id="clip0_92_1612">
          <rect width="24" height="6" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<style lang="scss" scoped>
.content-panel {
  &::-webkit-scrollbar {
    display: block;
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #333333;
    width: 8px;
  }
}
</style>
